var sliderDestination = -310;
var sliderStatus = null;
var valid = null;

function handle_radio_validation(o){
	var list = [];
	o.up('form').select('input.validate').each(function(o2){ if(o2.type == 'radio'){ list.push(o2); } });
	if(list.length > 0){
		var ob = list[list.length-1];
		ob.addClassName('validate-radio');
		return ob;
	}
}
function fieldset_toggle(ob){
	ob = $(ob);
	switch(ob.tagName.toLowerCase()){
		case 'div':
			ob.hide();
			ob.next().show();
			break;
		case 'legend':
			ob = ob.up();
			ob.hide();
			ob.previous().show();
			break;
	}
}
function confirmPost(oid){
	var o = $('on_order_item_'+oid);
	var myHTML = '<form action="inventory/cancelorder/" method="post" name="" class="center">'
		+ '<p>' + get_language_translation('LANG_ARE_YOU_SHURE_YOU_WANT_TO_REMOVE_ALL_RECORDS_OF_THIS_ORDER') + ' '
		+ '<br /><strong>' + get_language_translation('LANG_THIS_CANNOT_BE_UNDONE') + '.</strong></p>'
		+ '<div><label>' + get_language_translation('LANG_LABEL_ITEM') + ': </label>'+o.childElements()[2].down().innerHTML+' ('+o.childElements()[3].innerHTML+')</div>'
		+ '<div><label>' + get_language_translation('LANG_LABEL_FROM') + ': </label>'+o.childElements()[5].innerHTML+'</div>'
		+ '<div><label>' + get_language_translation('LANG_LABEL_TO') + ': </label>'+o.childElements()[1].innerHTML+'</div>'
		+ '<p>'+o.childElements()[7].innerHTML+' ' + get_language_translation('LANG_OF') + ' '+o.childElements()[6].innerHTML+' '+ get_language_translation('LANG_RECEIVED_SO_FAR') + '.</p>'
		+ '<div><label>' + get_language_translation('LANG_OPT_ORDERED') + ': </label>'+o.childElements().first().innerHTML+'</div>'
		+ '<input type="hidden" name="order_id" value="'+oid+'"/>'
		+ '<br/><div class="inlinebutton_wrapper"><a onclick="return MoxForm.Go(this)" class="am-btn am-btn--tonal"><span><i class="fa fa-trash"></i>' + get_language_translation('LANG_LABEL_DELETE') + '</span></a> '
		+ '<a class="am-btn am-btn--tonal" onclick="Modalbox.hide(); return false;"><span><i class="fal fa-times"></i>' + get_language_translation('LANG_BTN_CANCEL') + '</span></a></div>'
		+ '</form>'; 
	
	Modalbox.show(myHTML,{
		title:      get_language_translation('LANG_ORDER_CANCELLATION'),
		width:      350
	});
	return false;
}
function cb3_set_value(e, v){
	e.setStyle({'backgroundPosition':'0 -'+(v*16)+'px'});
}
function cb3_check_uncheck_all(e) {
	$$('.'+e.getAttribute('rel')).each(function(cb) {
		var t = $(cb.getAttribute('rel'));
		t.value = e.checked + 1;
		cb3_set_value(cb, e.checked+1);
	})
}
// This version of cb3 expects HTML like <span class="cb3"><input type="hidden" /></span>; no need for "rel" attribute.
function cb3_click(cb)
{
	var input = cb.down('input');
	input.value = (input.value + 1) % 3;
	cb3_set_value(cb, input.value);
}
// This version of cb3 expects HTML like <span class="cb3"><input type="hidden" /></span>; no need for "rel" attribute.
function sync_cb3_with_group(cb, container)
{
	cb3_click(cb);
	var value = cb.down('input').value;
	cb3_set_value(cb, value);
	container.select('span.cb3').each(function(element)
	{
		element.down('input').value = value;
		cb3_set_value(element, value);
	});
}

function cb_set_default_addr(target)
{
	if(!target.checked)
		return;
	var target_type = target.up('div.address').down('select[id^="type"]').value;
	$$('div.address').each(function(addr)
	{
		if(addr.down('select[id^="type"]').value == target_type){
			addr.down('input[id^="defaultaddr_"]').checked = false;
			addr.down('input[id^="defaultaddr_"]').removeAttribute('checked');
		}
	});
	target.checked = true;
}

function submitInvChk(o){
	var form = o.up('form');
	form.setAttribute('action','inventory/'+o.getAttribute('rel')+'/');
	return MoxForm.Go(o, function(mox){
		mox.validate(!(!$F('location_0')), 'location_0', get_language_translation('LANG_PLEASE_SEL_A_LOCATION') + '.');
		if(o.hasClassName('check_out'))
		{
			mox.validate($('from_inv_qty') ? !($F('quantity') > Number($('from_inv_qty').innerHTML)) : false, 'quantity', get_language_translation('LANG_YOU_CANT_CHECK_OUT_MORE_THAN_THERE_ARE') + '.');
			mox.validate(true, 'to_location_0');
			mox.validate(true, 'from_to_location_error_placeholder');
		}
		else if(o.hasClassName('check_in'))
		{
			mox.validate(true,o);
			mox.validate(true, 'to_location_0');
			mox.validate(true, 'from_to_location_error_placeholder');
		}
		else
		{
			mox.validate(!(!$F('to_location_0')), 'to_location_0', get_language_translation('LANG_PLEASE_SEL_A_LOCATION') + '.');
			mox.validate(!($F('location_0') == $F('to_location_0')), 'from_to_location_error_placeholder', get_language_translation('LANG_FROM_AND_TO_LOCATIONS_MUST_BE_DIFFIRENT') + '.');
			mox.validate($('from_inv_qty') ? !($F('quantity') > Number($('from_inv_qty').innerHTML)) : false, 'quantity', get_language_translation('LANG_YOU_CANNOT_MOVE_MORE_ITEMS_THAN_WHAT_ARE_AVAIL_AT_THE_FROM_LOCATION') + ' (' + ($('from_inv_qty') ? $('from_inv_qty').innerHTML : 0) + ').');
		}
		if($F('quantity') <= 0) // above validations remove auto-validation errors on this field
			mox.validate(false, 'quantity', get_language_translation('LANG_PLZ_ENTER_A_POSITIVE_NON_ZERO_QTY'));

		//THIS IS STUFF THAT MAKES THE INVENTORY CHECKIN/CHECKOUT AJAX'IE
		if(!mox.failed){
			var path = document.location.pathname;
			var item_id = $($('il_0').options[$('il_0').selectedIndex]).readAttribute('rel');
			if (!(	( !$F('order_id').blank() && path.include('orders/allocation/'+$F('order_id')) ) ||
					( path.include('inventory/processing') )||
					( path.include('inventory/edit/'+item_id) )
			)){
				mox.form.request({
					onSuccess: function(transport) {
						var message = transport.responseJSON;
						add_notification(message.text, message.type);
						Modalbox.hide();
					}
				});
				mox.failed = true;
			}
			else mox.ajax = false;
		}
	});
}

//Stuff to handle marking tasks as complete:
var waiting = false;
function mark_task_as_complete(task_id){
	if(waiting){
		$('task_'+task_id).down('input').checked = false;
		return false;
	}
	waiting = true;
	var el = $('task_'+task_id);
	el.addClassName('line-through');
	var url = 'tasks/mark_as_complete/' + task_id + '/';

	new Ajax.Request(url, {
		onSuccess: function(transport) {
			waiting = false;
			var success_div = new Element('div').update(transport.responseText);
			el.replace(success_div);
			success_div.highlight({endcolor: hlcolor(success_div)}).fade({ delay: 3.5, afterFinish: function() { declare_empty_taskbox(success_div); }});
		}, 
		onFailure: function(transport) {
			var error_div = new Element('p', {'class': 'error'}).update(get_language_translation('LANG_ERROR_MARKING_TASK_AS_COMPLETE_YOU_MAY_NOT_BE_AUTH_TO_MARK_THAT_TASK_AS_COMPLETE'));
			$('notifications').insert(error_div);
			error_div.fade({ delay: 3.5 });
			el.removeClassName('line-through');
		}
	});
}
var waiting2 = false;
function snooze_task(task_id) {
	if(waiting2){
		$('task_'+task_id).down('input').checked = false;
		return false;
	}
	waiting2 = true;
	var el = $('task_'+task_id);
	el.addClassName('line-through');
	var url = 'tasks/snooze/' + task_id + '/';

	new Ajax.Request(url, {
		onSuccess: function(transport) {
			waiting2 = false;
			var success_div = new Element('div').update(transport.responseText);
			el.replace(success_div);
			success_div.highlight({endcolor: hlcolor(success_div)}).fade({ delay: 3.5, afterFinish: function() { declare_empty_taskbox(success_div); }});
		}, 
		onFailure: function(transport) {
			var error_div = new Element('p', {'class': 'error'}).update(get_language_translation('LANG_ERROR_MARKING_TASK_AS_COMPLETE_YOU_MAY_NOT_BE_AUTH_TO_MARK_THAT_TASK_AS_COMPLETE'));
			$('notifications').insert(error_div);
			error_div.fade({ delay: 3.5 });
			el.removeClassName('line-through');
		}
	});
	return false;
}
function declare_empty_taskbox(el)
{
	el.remove();
	if(!$('my_task_box').children.length) /*|| !$('my_task_box').children[0].hasClassName('task')*/
		$('my_task_box').insert('<div>' + get_language_translation('LANG_THERE_ARE_NO_MORE_TASKS') + '.</div>');
}
function initialize_task_day_sortables(){
	$$('.task_day').each(function(div){
		Sortable.destroy(div.id);
		Sortable.create(div.id, {
			onUpdate: function() {
				var testrequest = new Ajax.Request("tasks/change_sort_order/", {
					parameters: { task_sort_orders: Sortable.serialize(div.id) },
					onSuccess: function(transport) {
						div.highlight({endcolor: hlcolor(div)});
					}
				});
			},
			tag: 'div',
			only: 'task'
		});
	});
}
//Start of http://www.isocra.com/ code
var currenttable = null;

document.onmousemove = function(ev){
 if (currenttable && currenttable.dragObject) {
	 ev   = ev || window.event;
	 var mousePos = currenttable.mouseCoords(ev);
	 var y = mousePos.y - currenttable.mouseOffset.y;
	 if (y != currenttable.oldY) {
		 // work out if we're going up or down...
		 var movingDown = y > currenttable.oldY;
		 // update the old value
		 currenttable.oldY = y;
		 // update the style to show we're dragging
		 currenttable.dragObject.style.backgroundColor = "#F8F8F8";
		 // If we're over a row then move the dragged row to there so that the user sees the
		 //  dynamically
		 var currentRow = currenttable.findDropTargetRow(y);
		 if (currentRow) {
			 if (movingDown && currenttable.dragObject != currentRow) {
				 currenttable.dragObject.parentNode.insertBefore(currenttable.dragObject, currentRow.nextSibling);
		 		 currenttable.onDrag(currenttable, currentRow)
			 } else if (! movingDown && currenttable.dragObject != currentRow) {
				 currenttable.dragObject.parentNode.insertBefore(currenttable.dragObject, currentRow);
		 		 currenttable.onDrag(currenttable, currentRow)
			 }
		 }
	 }
	 return false;
 }
}
//Similarly for the mouseup
document.onmouseup   = function(ev){
 if (currenttable && currenttable.dragObject) {
	 var droppedRow = currenttable.dragObject;
	 // If we have a dragObject, then we need to release it,
	 // The row will already have been moved to the right place so we just reset stuff
	 droppedRow.style.backgroundColor = 'transparent';
	 currenttable.dragObject   = null;
	 // And then call the onDrop method in case anyone wants to do any post processing
	 currenttable.onDrop(currenttable.table, droppedRow);
	 currenttable = null; // let go of the table too
 }
}

/** get the source element from an event in a way that works for IE and Firefox and Safari
* @param evt the source event for Firefox (but not IE--IE uses window.event) */
function getEventSource(evt) {
 if (window.event) {
	 evt = window.event; // For IE
	 return evt.srcElement;
 } else {
	 return evt.target; // For Firefox
 }
}
/**
* Encapsulate table Drag and Drop in a class. We'll have this as a Singleton
* so we don't get scoping problems.
*/
function TableDnD(table) {
 if (table)
 	return TableDnD.tables[table]

 /** Keep hold of the current drag object if any */
 this.dragObject = null;
 /** The current mouse offset */
 this.mouseOffset = null;
 /** The current table */
 this.table = null;
 /** Remember the old value of Y so that we don't do too much processing */
 this.oldY = 0;

 /** Initialise the drag and drop by capturing mouse move events */
 this.init = function(table) {
 	 TableDnD.tables[table] = this
	 this.table = table;
	 var rows = table.tBodies[0].rows; //getElementsByTagName("tr")
	 for (var i=0; i<rows.length; i++) {
			// John Tarr: added to ignore rows that I've added the NoDnD attribute to (Category and Header rows)
			var nodrag = rows[i].getAttribute("NoDrag")
			if (nodrag == null || nodrag == "undefined") { //There is no NoDnD attribute on rows I want to drag
				this.makeDraggable(rows[i]);
			}
	 }
 }

 /** This function is called when you drop a row, so redefine it in your code
	 to do whatever you want, for example use Ajax to update the server */
 this.onDrop = function(table, droppedRow) {
	 // Do nothing for now
 }

 /** This function is called when you drop a row, so redefine it in your code
	 to do whatever you want, for example use Ajax to update the server */
 this.onDrag = function(table, draggedRow) {
	 // Do nothing for now
 }

	/** Get the position of an element by going up the DOM tree and adding up all the offsets */
 this.getPosition = function(e){
	 var left = 0;
	 var top  = 0;
		/** Safari fix -- thanks to Luis Chato for this! */
		if (e.offsetHeight == 0) {
			/** Safari 2 doesn't correctly grab the offsetTop of a table row
				this is detailed here:
				http://jacob.peargrove.com/blog/2006/technical/table-row-offsettop-bug-in-safari/
				the solution is likewise noted there, grab the offset of a table cell in the row - the firstChild.
				note that firefox will return a text node as a first child, so designing a more thorough
				solution may need to take that into account, for now this seems to work in firefox, safari, ie */
			e = e.firstChild; // a table cell
		}

	 while (e.offsetParent){
		 left += e.offsetLeft;
		 top  += e.offsetTop;
		 e     = e.offsetParent;
	 }

	 left += e.offsetLeft;
	 top  += e.offsetTop;

	 return {x:left, y:top};
 }

	/** Get the mouse coordinates from the event (allowing for browser differences) */
 this.mouseCoords = function(ev){
	 if(ev.pageX || ev.pageY){
		 return {x:ev.pageX, y:ev.pageY};
	 }
	 return {
		 x:ev.clientX + document.body.scrollLeft - document.body.clientLeft,
		 y:ev.clientY + document.body.scrollTop  - document.body.clientTop
	 };
 }

	/** Given a target element and a mouse event, get the mouse offset from that element.
		To do this we need the element's position and the mouse position */
 this.getMouseOffset = function(target, ev){
	 ev = ev || window.event;

	 var docPos    = this.getPosition(target);
	 var mousePos  = this.mouseCoords(ev);
	 return {x:mousePos.x - docPos.x, y:mousePos.y - docPos.y};
 }

	/** Take an item and add an onmousedown method so that we can make it draggable */
 this.makeDraggable = function(item) {
	 if(!item) return;
	 var self = this; // Keep the context of the TableDnd inside the function
	 item.onmousedown = function(ev) {
		 // Need to check to see if we are an input or not, if we are an input, then
		 // return true to allow normal processing
		 var target = getEventSource(ev);
		 if (target.tagName == 'INPUT' || target.tagName == 'SELECT') return true;
		 currenttable = self;
		 self.dragObject  = this;
		 self.mouseOffset = self.getMouseOffset(this, ev);
		 return false;
	 }
	 item.style.cursor = "move";
 }

 /** We're only worried about the y position really, because we can only move rows up and down */
 this.findDropTargetRow = function(y) {
	 var rows = this.table.tBodies[0].rows;
		for (var i=0; i<rows.length; i++) {
			var row = rows[i];
			// John Tarr added to ignore rows that I've added the NoDnD attribute to (Header rows)
			var nodrop = row.getAttribute("NoDrop");
			if (nodrop == null || nodrop == "undefined") {  //There is no NoDnD attribute on rows I want to drag
				var rowY    = this.getPosition(row).y;
				var rowHeight = parseInt(row.offsetHeight)/2;
				if (row.offsetHeight == 0) {
					rowY = this.getPosition(row.firstChild).y;
					rowHeight = parseInt(row.firstChild.offsetHeight)/2;
				}
				// Because we always have to insert before, we need to offset the height a bit
				if ((y > rowY - rowHeight) && (y < (rowY + rowHeight))) {
					// that's the row we're over
					return row;
				}
			}
		}
		return null;
	}
}
TableDnD.tables = {}

/*************************** END OF THE PASTE *********************************/
document.observe("dom:loaded", function(){
	initialize_task_day_sortables();
	if($('attr_rows')){
		var tableDnD = new TableDnD();
		tableDnD.init($('attr_rows').up());
	}
});

function slider(){
	var o = $('toolbar');
	var l = parseFloat(o.getStyle('left'));
	if(sliderDestination <= l + 2 && sliderDestination >= l - 2){
		o.setStyle({'left':sliderDestination + "px"});
	} else {
		o.setStyle({'left':parseFloat((l * 3 + sliderDestination) / 4) + "px"});
		sliderStatus = setTimeout("slider('toolbar')",60);
	}
}
function set_default(ob, def){
	if($F(ob).blank()){
		$(ob).addClassName('default');
		ob.value = def;
	}
	return;
}
function select_to_show(selectbox){
	var hide_me = $(selectbox).form.select('.shown_by_select')[0];
	if(hide_me){
		hide_me.hide();
		hide_me.removeClassName('shown_by_select');
	}
	if(!Number($F(selectbox))) return false;
	var show_me = $(selectbox).form.select('fieldset')[Number($F(selectbox))];
	show_me.show();
	show_me.addClassName('shown_by_select');
	return false;
}
function sync_cb(cb){
	//cb.checked = !cb.checked;
	var theForm = cb.form, z = -1;
	while (theForm[++z]) {
		if (theForm[z].type=='checkbox' && theForm[z].name != 'checkall' && !theForm[z].hasClassName('no_sync'))
			theForm[z].checked = cb.checked;
	}
}
function sync_cb_with_filter(cb,filter){
	//cb.checked = !cb.checked;
	var theForm = cb.form, z = -1;
	while (theForm[++z]) {
		if (theForm[z].type=='checkbox' && $(theForm[z]).hasClassName(filter))
			theForm[z].checked = cb.checked;
	}
}
function sync_cb_with_group(cb, container)
{
	container.select('input[type=checkbox]').each(function(element)
	{
		element.checked = cb.checked;
	});
}


function callInProgress (xmlhttp) {
	switch (xmlhttp.readyState) {
		case 1: case 2: case 3:
			return true;
			break;
		// Case 4 and 0
		default:
			return false;
			break;
	}
}
function enable_formula_name(el, id) {
	if (id) {
		var display_box = $('parts[n'+id+'][display_name]');
		var formula_box = $('parts[n'+id+'][name]');
	}
	else {
		var display_box = el.down('input[type=text]');
		var formula_box = el.down('input[type=hidden]');
	}
	if (!formula_box || !display_box) {
		return;
	}
	formula_box.type = 'text';
	const next = formula_box.next();
	if (next) {
		next.update();
	}
	display_box.observe('keyup',function(ev) {
		formula_box.value = display_box.value.toLowerCase().replace(/[^a-z0-9]+/g,'_');
	});
}

// Set end color for highlight fading
function hlcolor(el)
{
	if(el.up('#rightside'))
		return '#3E3E3E';
	else
		return '#FFFFFF';
}

function is_numeric(number)
{
	return !isNaN(parseFloat(number)) && isFinite(number);
}

function is_infinity(number)
{
	return number.toString() === 'Infinity' || number.toString() === '-Infinity';
}

function isJson(value) {
	try {
		value = JSON.stringify(value);
		JSON.parse(value);
		return true;
	} catch (e) {
		return false;
	}
}

function debounce(callback, delay = 250) {
    let timeout;

    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            callback(...args);
        }, delay);
    };
}

function address_dirty(t){
	var uid = t.id.split("_")[1];
	if(am.$('#'+t.id).val().length > 0){
		am.$('#name_'+uid).addClass("required");
		am.$('#city_'+uid).addClass("required");
		am.$('#country_'+uid).addClass("required");
		am.$('#state_'+uid).addClass("required");
		am.$('#zip_'+uid).addClass("required");
	}
	else{
		am.$('#name_'+uid).removeClass("required");	
		am.$('#city_'+uid).removeClass("required");
		am.$('#country_'+uid).removeClass("required");
		am.$('#state_'+uid).removeClass("required");
		am.$('#zip_'+uid).removeClass("required");
	}
}
function simpleValidateHtmlStr(htmlStr, detailed = false) {
    // --- 1. Type check ---
    if (typeof htmlStr !== "string") {
        const r = { valid: false, type: "format", error: "Value must be a string." };
        return detailed ? r : false;
    }
    htmlStr = htmlStr.trim();
    if (htmlStr === "") {
        const r = { valid: false, type: "format", error: "Value cannot be empty." };
        return detailed ? r : false;
    }

    // --- 2. Safer dangerous pattern checks ---
    const dangerousPatterns = [
        { name: "script_open",  pattern: /<\s*script\b[^>]*>/i,  type: "security", error: "Script tags are not allowed." },
        { name: "script_close", pattern: /<\s*\/\s*script\s*>/i, type: "security", error: "Closing script tags are not allowed." },
        { name: "inline_handler", pattern: /on\w+\s*=/i, type: "security", error: "Inline event handlers (onclick, onload, etc.) are not allowed." },
        { name: "js_proto", pattern: /\bjavascript:/i, type: "security", error: "JavaScript URLs are not allowed." },
        { name: "vb_proto", pattern: /\bvbscript:/i, type: "security", error: "VBScript URLs are not allowed." },
        { name: "data_uri", pattern: /\bdata:(?!image\/(?:png|jpe?g|gif|webp|bmp);)/i, type: "security", error: "Non-image data URIs are not allowed." },
        { name: "unsafe_tags", pattern: /<\s*(iframe|object|embed|applet|form)\b/i, type: "security", error: "Potentially unsafe HTML tags are not allowed." },
        { name: "css_expr", pattern: /expression\s*\(/i, type: "security", error: "CSS expressions are not allowed." },
        { name: "css_url_js", pattern: /url\s*\(\s*['"]?\s*javascript:/i, type: "security", error: "JavaScript inside CSS url() is not allowed." },
        { name: "css_behavior", pattern: /behavior\s*:/i, type: "security", error: "CSS behavior properties are not allowed." },
        { name: "moz_binding", pattern: /-moz-binding/i, type: "security", error: "Mozilla CSS bindings are not allowed." },
        { name: "xml_entity", pattern: /<!entity/i, type: "security", error: "XML entity declarations are not allowed." },
        { name: "encoded_script_angle", pattern: /&#x?0*3c;?\s*script/i, type: "security", error: "Encoded <script> tag is not allowed." }
    ];

    // Check for any pattern hit
    for (const { name, pattern, type, error } of dangerousPatterns) {
        const match = htmlStr.match(pattern);
        if (match) {
            const r = { valid: false, type, error, match: name };
            return detailed ? r : false;
        }
    }

    // --- 3. Build DOM to check attributes & structure ---
    const sdom = document.createElement("div");
    try {
        sdom.innerHTML = htmlStr;

        // Attribute scan
        const allElements = sdom.getElementsByTagName("*");
        for (let el of allElements) {
            for (let attr of el.attributes) {
                const name = attr.name.toLowerCase();
                const value = attr.value.toLowerCase();
                const isSafeImageDataUri = /^\s*data:image\/(png|jpe?g|gif|webp|bmp);/i.test(attr.value);
                if (name.startsWith("on") ||
                    value.includes("javascript:") ||
                    (value.includes("data:") && !isSafeImageDataUri) ||
                    value.includes("vbscript:")) {
                    const r = {
                        valid: false,
                        type: "security",
                        error: `Unsafe attribute "${attr.name}" found in <${el.tagName.toLowerCase()}>.`,
                        match: name
                    };
                    return detailed ? r : false;
                }
            }
        }

        // Tag balance
        const tagPattern = /<\/?([a-z]+)[^>]*>/gi;
        const voidEls = new Set(["br","hr","img","input","meta","link","source","area","base","col","embed","track","wbr"]);
        const stack = [];
        let m;
        while ((m = tagPattern.exec(htmlStr)) !== null) {
            const full = m[0], tag = m[1].toLowerCase();
            if (voidEls.has(tag)) continue;
            if (full.startsWith("</")) {
                if (stack.length === 0 || stack.pop() !== tag) {
                    const r = { valid: false, type: "syntax", error: `Unmatched closing tag </${tag}> detected.`, match: tag };
                    return detailed ? r : false;
                }
            } else if (!full.endsWith("/>")) stack.push(tag);
        }
        if (stack.length > 0) {
            const r = { valid: false, type: "syntax", error: `Unclosed tag <${stack.pop()}> detected.`, match: "tag_balance" };
            return detailed ? r : false;
        }

        // Passed
        const ok = { valid: true, type: null, error: null };
        return detailed ? ok : true;

    } catch (err) {
        const r = { valid: false, type: "runtime", error: `Validation failed: ${err.message}` };
        return detailed ? r : false;
    }
}